<template>
    <div class="filter-box">
        <v-expansion-panels :value="open" @change="changeOpen">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class="collapsable-header">
                        <div class="bold">Infrastruktur</div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="collapsable-inner">
                        <div class="filter-content">
                            <v-checkbox
                                v-model="infra"
                                value="0"
                                label="Rollstuhl geeignet"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>

                            <v-checkbox
                                v-model="infra"
                                value="1"
                                label="Kinderwagen geeignet"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>

                            <v-checkbox
                                v-model="infra"
                                value="2"
                                label="Erreichbar mit ÖV"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>

                            <v-checkbox
                                v-model="infra"
                                value="3"
                                label="Parkplätze"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>

                            <v-checkbox
                                v-model="infra"
                                value="4"
                                label="WC"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>

                            <v-checkbox
                                v-model="infra"
                                value="5"
                                label="Trinkwasser"
                                color="#33bbff"
                                hide-details
                            ></v-checkbox>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    props: ["filters", 'open', 'resetSignal'],
    data() {
        return {
            infra: [],
        };
    },
    watch: {
        infra() {
            //console.log(this.infra);
            this.$emit("input", this.infra);
        },
        resetSignal(newVal, oldVal) {
            if (newVal !== oldVal && newVal === true) {
                this.infra = [];
            }
        }
    },
    methods: {
        changeOpen(val) {
            this.$emit('open', val);
        },
    }
};
</script>

<style>
</style>
